import React, { useState, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import FormTitle from "../../../components/FormTitle";
import Input from "../../../components/FormInputs";
import CustomButton from "../../../components/AddButton";
import ExecutiveDetailsModal from "../../../components/Closemodel/closemodel";
import { Plus } from "../../../common/svg";
import PhoneInput from "../../../components/phoneinput";
import { PaymentDetailsProps } from "../../../service/interfaces/Components";
import { ApiService } from "../../../service/api.service";
import { OPERTIONS_URL } from "../../../common/common";

const BillingDetails: React.FC<PaymentDetailsProps> = ({
  errors,
  register,
  control,
  setBillingDetailData,
  billingDetailData,
  setShippingDetailsData,
  shippingDetailsData,
  setValue,
  clientData,
}) => {
  const [useSameContact, setUseSameContact] = useState<boolean>(false);
  const [useSameBillingContact, setUseSameBillingContact] = useState<boolean>(false);
  const [shippingForms, setShippingForms] = useState<number[]>([1]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [formIdToRemove, setFormIdToRemove] = useState<number | null>(null);
  const [clientContactNumber, setClientContactNumber] = useState<any>("");
  const [clientemailId, setClientEmailId] = useState<string>("");

  const watchedValues = useWatch({ control });
  const apiService = new ApiService();
  // Helper function to check if shipping field has error
  const hasShippingFieldError = (index: number, fieldName: string): boolean => {
    if (!errors.shippingDetails) return false;
    return !!errors.shippingDetails[index]?.[fieldName];
  };
  // Helper function to get shipping field error message
  const getShippingFieldError = (index: number, fieldName: string): string => {
    if (!errors.shippingDetails) return "";
    const errorMessage = errors.shippingDetails[index]?.[fieldName]?.message;
    return typeof errorMessage === "string" ? errorMessage : "";
  };

  useEffect(() => {
    setBillingDetailData({
      address1: watchedValues.billingAddressLine1 || "",
      address2: watchedValues.billingAddressLine2 || "",
      city: watchedValues.billingCity || "",
      pincode: watchedValues.billingPincode || "",
      state: watchedValues.billingState || "",
      country: watchedValues.billingCountry || "",
      mobile: watchedValues.billingPhoneNumber || "",
      countryCode: watchedValues.countryCode || "",
      email: watchedValues.billingEmail || "",
    });
  }, [watchedValues, setBillingDetailData]);

  // Update shipping details in state when form data changes
  useEffect(() => {
    if (!watchedValues.shippingDetails) return;

    const shippingAddresses = shippingForms.map((_, index) => {
      const shippingData = watchedValues.shippingDetails[index] || {};
      return {
        address1: shippingData.addressLine1 || "",
        address2: shippingData.addressLine2 || "",
        city: shippingData.city || "",
        pincode: shippingData.pincode || "",
        state: shippingData.state || "",
        country: shippingData.country || "",
        mobile: shippingData.phoneNumber || "",
        countryCode: shippingData.countryCode,
        email: shippingData.email || "",
      };
    });

    setShippingDetailsData(shippingAddresses);
  }, [watchedValues, shippingForms, setShippingDetailsData]);

  // Auto-fill shipping with billing data when checkbox is toggled
  useEffect(() => {
    try {
      console.log("useSameContact", useSameContact, "clientData", clientData);
      const getClient = async () => {
        const response: any = await apiService.getApi(
          `${OPERTIONS_URL}/client/details-route?clientId=${clientData.clientId}`
        );
        if (response.status === "200") {
          const data = response.body[0];
          if (data.billingDetail) {
            setValue("billingAddressLine1", data.billingDetail.address1 || "");
            setValue("billingAddressLine2", data.billingDetail.address2 || "");
            setValue("billingCity", data.billingDetail.city || "");
            setValue("billingPincode", data.billingDetail.pincode || "");
            setValue("billingState", data.billingDetail.state || "");
            setValue("billingCountry", data.billingDetail.country || "");
            setValue("billingPhoneNumber", clientData.contactNumber || "");
            setValue("billingEmail", clientData.emailId || "");
          }
        }
      };
      if (useSameContact && clientData) {
        getClient();
      } else {
        setValue("billingPhoneNumber", billingDetailData.mobile);
        setValue("billingEmail", billingDetailData.email);
        setValue("billingAddressLine1", billingDetailData.address1);
        setValue("billingAddressLine2", billingDetailData.address2);
        setValue("billingCity", billingDetailData.city);
        setValue("billingPincode", billingDetailData.pincode);
        setValue("billingState", billingDetailData.state);
        setValue("billingCountry", billingDetailData.country);
      }
    } catch (error) {
      console.error("Error setting billing details:", error);
    }
  }, [useSameContact, clientData]);

  useEffect(() => {
    // Only run when the checkbox value changes and data is available
    console.log(billingDetailData, "data");
    if (useSameBillingContact && billingDetailData) {
      setValue(`shippingDetails[0].addressLine1`, billingDetailData.address1 || "");
      setValue(`shippingDetails[0].addressLine2`, billingDetailData.address2 || "");
      setValue(`shippingDetails[0].city`, billingDetailData.city || "");
      setValue(`shippingDetails[0].pincode`, billingDetailData.pincode || "");
      setValue(`shippingDetails[0].state`, billingDetailData.state || "");
      setValue(`shippingDetails[0].country`, billingDetailData.country || "");
      setValue(`shippingDetails[0].phoneNumber`, billingDetailData.mobile || "");
      setValue(`shippingDetails[0].countryCode`, billingDetailData.countryCode || "");
      setValue(`shippingDetails[0].email`, billingDetailData.email || "");
    } else if (shippingDetailsData?.[0]) {
      // Only attempt to reset if shippingDetailsData[0] is defined
      setValue(`shippingDetails[0].addressLine1`, shippingDetailsData[0].address1 || "");
      setValue(`shippingDetails[0].addressLine2`, shippingDetailsData[0].address2 || "");
      setValue(`shippingDetails[0].city`, shippingDetailsData[0].city || "");
      setValue(`shippingDetails[0].pincode`, shippingDetailsData[0].pincode || "");
      setValue(`shippingDetails[0].state`, shippingDetailsData[0].state || "");
      setValue(`shippingDetails[0].country`, shippingDetailsData[0].country || "");
      setValue(`shippingDetails[0].phoneNumber`, shippingDetailsData[0].mobile || "");
      setValue(`shippingDetails[0].countryCode`, shippingDetailsData[0].countryCode || ""); // fixed: was using country instead
      setValue(`shippingDetails[0].email`, shippingDetailsData[0].email || "");
    }
  }, [useSameBillingContact]);
  
  

  const addNewShippingForm = () => {
    setShippingForms([...shippingForms, shippingForms.length + 1]);
  };

  const openModal = (formId: number) => {
    setFormIdToRemove(formId);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  const handleConfirmRemove = () => {
    if (formIdToRemove !== null) {
      setShippingForms((prevForms) =>
        prevForms.filter((id) => id !== formIdToRemove)
      );
      setFormIdToRemove(null);
      closeModal();
    }
  };


  return (
    <div className="bg-white p-6 rounded-[20px] font-poppins mb-6">
      {/* Billing Address Section */}
      <div className="flex items-center justify-between mb-4">
        <FormTitle title="Billing Address Details" />
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            className="w-[20px] h-[20px]"
            checked={useSameContact}
            onChange={(e) => setUseSameContact(e.target.checked)}
          />
          <label className="text-[16px] font-[400] font-poppins">
            Use Same Client Details
          </label>
        </div>
      </div>

      {/* Billing Address Fields */}
      <div className="mt-4 grid grid-cols-4 gap-x-6 gap-y-4 ">
        <Input
          label="Address Line 1"
          name="billingAddressLine1"
          errors={errors}
          register={register}
          placeholder="Enter Address Line 1"
        />
        <Input
          label="Address Line 2"
          name="billingAddressLine2"
          errors={errors}
          register={register}
          placeholder="Enter Address Line 2"
        />
        <Input
          label="City"
          name="billingCity"
          errors={errors}
          register={register}
          placeholder="Enter City"
        />
        <Input
          label="Pincode"
          name="billingPincode"
          errors={errors}
          register={register}
          placeholder="Enter Pincode"
          type="number"
          maxLength={6}
        />
        <Input
          label="State"
          name="billingState"
          errors={errors}
          register={register}
          placeholder="Enter State"
        />
        <Input
          label="Country"
          name="billingCountry"
          errors={errors}
          register={register}
          placeholder="Enter Country"
        />
        <PhoneInput
          label="Phone Number"
          name="billingPhoneNumber"
          defaultCountry="IN"
          type="tel"
          errors={errors}
          control={control}
          placeholder="Enter your phone number"
          defaultValue={{
            countryCode: watchedValues?.countryCode || "",
            phoneNumber: watchedValues?.billingPhoneNumber || "",
          }}
          onChange={({ countryCode, phoneNumber }) => {
            setValue("billingPhoneNumber", phoneNumber);
            setValue("countryCode", countryCode);
          }}
        />

        <Input
          label="Email"
          name="billingEmail"
          errors={errors}
          register={register}
          placeholder="Enter Email Address"
          defaultValue={clientemailId}
        />
      </div>
      <div className="border-b border-[#C1C1C1] border-dashed mt-4 w-full"></div>

      <br />

      {/* Shipping Address Section */}
      <div className="flex items-center justify-between ">
        <FormTitle title="Shipping Address Details" />

        <CustomButton label="" icon={Plus} onClick={addNewShippingForm} />
      </div>
      <div>
        <div className="flex items-center justify-end gap-2">
          <input
            type="checkbox"
            className="w-[20px] h-[20px]"
            checked={useSameBillingContact}
            onChange={(e) => setUseSameBillingContact(e.target.checked)}
          />
          <label className="text-[16px] font-[400] font-poppins">
            Use Same Billing Details
          </label>
        </div>
      </div>
      {/* Shipping Address Fields */}
      <div className="">
        {shippingForms.map((formId, index) => (
          <div key={formId} className="border-b border-dashed pb-4">
            <div className="flex items-center justify-end mb-2 gap-4">
              <p className="text-[14px] font-[600]">
                #{(index + 1).toString().padStart(2, "0")}
              </p>
              {index >= 1 && (
                <div className="flex items-center justify-end">
                  <button
                    onClick={() => openModal(formId)}
                    type="button"
                    className="bg-red-500 text-white p-1 rounded-full shadow-md hover:bg-red-600 transition-all"
                    aria-label="Remove"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
            <div className="mt-4 grid grid-cols-4 gap-x-6 gap-y-4">
              <Input
                label="Address Line 1"
                name={`shippingDetails[${index}].addressLine1`}
                errors={
                  hasShippingFieldError(index, "addressLine1")
                    ? {
                        [`shippingDetails[${index}].addressLine1`]: {
                          message: getShippingFieldError(index, "addressLine1"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter Address Line 1"
              />
              <Input
                label="Address Line 2"
                name={`shippingDetails[${index}].addressLine2`}
                errors={
                  hasShippingFieldError(index, "addressLine2")
                    ? {
                        [`shippingDetails[${index}].addressLine2`]: {
                          message: getShippingFieldError(index, "addressLine2"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter Address Line 2"
              />
              <Input
                label="City"
                name={`shippingDetails[${index}].city`}
                errors={
                  hasShippingFieldError(index, "city")
                    ? {
                        [`shippingDetails[${index}].city`]: {
                          message: getShippingFieldError(index, "city"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter City"
              />
              <Input
                label="Pincode"
                name={`shippingDetails[${index}].pincode`}
                errors={
                  hasShippingFieldError(index, "pincode")
                    ? {
                        [`shippingDetails[${index}].pincode`]: {
                          message: getShippingFieldError(index, "pincode"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter Pincode"
                type="number"
                maxLength={6}
              />
              <Input
                label="State"
                name={`shippingDetails[${index}].state`}
                errors={
                  hasShippingFieldError(index, "state")
                    ? {
                        [`shippingDetails[${index}].state`]: {
                          message: getShippingFieldError(index, "state"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter State"
              />
              <Input
                label="Country"
                name={`shippingDetails[${index}].country`}
                errors={
                  hasShippingFieldError(index, "country")
                    ? {
                        [`shippingDetails[${index}].country`]: {
                          message: getShippingFieldError(index, "country"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter Country"
              />
              <PhoneInput
                label="Phone Number"
                name={`shippingDetails[${index}].phoneNumber`}
                defaultCountry="IN"
                type="tel"
                errors={
                  hasShippingFieldError(index, "phoneNumber")
                    ? {
                        [`shippingDetails[${index}].phoneNumber`]: {
                          message: getShippingFieldError(index, "phoneNumber"),
                        },
                      }
                    : {}
                }
                control={control}
                maxLength={10}
                placeholder="Enter your phone number"
                defaultValue={{
                  countryCode:
                    watchedValues?.shippingDetails?.[index]?.countryCode || "",
                  phoneNumber:
                    watchedValues?.shippingDetails?.[index]?.phoneNumber || "",
                }}
                onChange={({ countryCode, phoneNumber }) => {
                  setValue(
                    `shippingDetails[${index}].phoneNumber`,
                    phoneNumber
                  );
                  setValue(
                    `shippingDetails[${index}].countryCode`,
                    countryCode
                  );
                }}
              />
              <Input
                label="Email"
                name={`shippingDetails[${index}].email`}
                errors={
                  hasShippingFieldError(index, "email")
                    ? {
                        [`shippingDetails[${index}].email`]: {
                          message: getShippingFieldError(index, "email"),
                        },
                      }
                    : {}
                }
                register={register}
                placeholder="Enter Email Address"
              />
            </div>
          </div>
        ))}
      </div>

      <ExecutiveDetailsModal
        isOpen={isModalOpen}
        onConfirm={handleConfirmRemove}
        onClose={closeModal}
      />
    </div>
  );
};

export default BillingDetails;
